module.exports = __webpack_public_path__ + "public/img/signup-link-illo.39fc58e.png";